import axios from 'axios';

export const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:4000/api').replace(/\/api$/, '');

const api = axios.create({
  baseURL: API_BASE + '/api',
});

export const inmueblesService = {
  getAll: () => api.get('/inmuebles'),
  getById: (id) => api.get(`/inmuebles/${id}`),
  create: (data) => api.post('/inmuebles', data),
  update: (id, data) => api.put(`/inmuebles/${id}`, data),
  delete: (id) => api.delete(`/inmuebles/${id}`),
};

export const inquilinosService = {
  getAll: () => api.get('/inquilinos'),
  getById: (id) => api.get(`/inquilinos/${id}`),
  create: (data) => api.post('/inquilinos', data),
  update: (id, data) => api.put(`/inquilinos/${id}`, data),
};

export const contratosService = {
  getAll: () => api.get('/contratos'),
  getById: (id) => api.get(`/contratos/${id}`),
  getByInmueble: (inmueble_id) => api.get(`/contratos/inmueble/${inmueble_id}`),
  create: (data) => api.post('/contratos', data),
  delete: (id) => api.delete(`/contratos/${id}`),
  proximosVencimientos: () => api.get('/contratos/proximos-vencimientos'),
};

export const documentosService = {
  getByEntidad: (tipo, id) => api.get(`/documentos/${tipo}/${id}`),
  subir: (formData) => api.post('/documentos', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  eliminar: (id) => api.delete(`/documentos/${id}`),
};

export const inmobiliariasService = {
  getAll: () => api.get('/inmobiliarias'),
  create: (data) => api.post('/inmobiliarias', data),
  update: (id, data) => api.put(`/inmobiliarias/${id}`, data),
  delete: (id) => api.delete(`/inmobiliarias/${id}`),
};

export const garantesService = {
  getAll: () => api.get('/garantes'),
  create: (data) => api.post('/garantes', data),
};

export const pagosService = {
  generar: (data) => api.post('/pagos/generar', data),
  getByMes: (anio, mes) => api.get(`/pagos/mes/${anio}/${mes}`),
  getStats: (anio, mes) => api.get(`/pagos/stats/${anio}/${mes}`),
  pagar: (id, data) => api.put(`/pagos/${id}/pagar`, data),
  anular: (id) => api.put(`/pagos/${id}/anular`),
};

export const movimientosService = {
  generarCargos: (data) => api.post('/movimientos/generar-cargos', data),
  getCuentaCorriente: (contratoId) => api.get(`/movimientos/contrato/${contratoId}`),
  getResumen: (desde, hasta) => api.get(`/movimientos/resumen?desde=${desde}&hasta=${hasta}`),
  getResumenMensual: (anio, mes) => api.get(`/movimientos/resumen-mensual/${anio}/${mes}`),
  pagar: (data) => api.post('/movimientos/pagar', data),
  ajuste: (data) => api.post('/movimientos/ajuste', data),
  eliminar: (id) => api.delete(`/movimientos/${id}`),
};

export const cuentasService = {
  getAll: () => api.get('/cuentas'),
  create: (data) => api.post('/cuentas', data),
  update: (id, data) => api.put(`/cuentas/${id}`, data),
  delete: (id) => api.delete(`/cuentas/${id}`),
};

export const aiService = {
  leerContrato: (formData) => api.post('/ai/leer-contrato', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000
  }),
  confirmarContrato: (formData) => api.post('/ai/confirmar-contrato', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000
  }),
};

export default api;
